import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import RequestDemo from './pages/request-demo';
import PlatformDemo from './pages/platform-demo';
import APIDocumentation from './pages/api-documentation';
import EnterpriseSolutions from './pages/enterprise-solutions';
import Homepage from './pages/homepage';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/request-demo" element={<RequestDemo />} />
        <Route path="/platform-demo" element={<PlatformDemo />} />
        <Route path="/api-documentation" element={<APIDocumentation />} />
        <Route path="/enterprise-solutions" element={<EnterpriseSolutions />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
